import { PlusIcon } from "@phosphor-icons/react";
import { LinkButton } from "@/components/ui/button";
import { BRIEFING_CREATE_PATH } from "./BriefingsIndexHeader";

const BRIEFINGS_INDEX_EMPTY_TITLE = "No briefings to show";

const BRIEFINGS_INDEX_EMPTY_BODY =
  "Briefings will appear here once they've been created";

interface BriefingsIndexEmptyViewProps {
  isFiltered?: boolean;
}

const BriefingsIndexEmptyView = ({
  isFiltered = false,
}: BriefingsIndexEmptyViewProps) => (
  <div className="flex min-w-0 flex-1 justify-center pt-[86px]">
    <div className="flex min-w-0 w-full max-w-sm flex-col items-start gap-1 text-left">
      <h2 className="text-base font-medium text-gray-900">
        {isFiltered
          ? "No briefings match your search or filter"
          : BRIEFINGS_INDEX_EMPTY_TITLE}
      </h2>
      <p className="w-full pb-3 text-sm text-gray-700">
        {isFiltered
          ? "Try adjusting your search or selecting a different status."
          : BRIEFINGS_INDEX_EMPTY_BODY}
      </p>
      {isFiltered ? null : (
        <LinkButton
          to={BRIEFING_CREATE_PATH}
          variant="outline"
          size="sm"
          className="h-8 gap-2"
        >
          <PlusIcon aria-hidden className="size-4 text-gray-600" />
          New briefing
        </LinkButton>
      )}
    </div>
  </div>
);

export default BriefingsIndexEmptyView;
